"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var json_1 = require("../utils/json");
var obfuscation_1 = require("../utils/obfuscation");
var StorageHelper = /** @class */ (function () {
    function StorageHelper(storageHelperOptions) {
        this.obfuscated = false;
        this.allowMultiple = false;
        this.type = storageHelperOptions.type;
        if (storageHelperOptions.obfuscated !== undefined) {
            this.obfuscated = storageHelperOptions.obfuscated;
        }
        if (storageHelperOptions.allowMultiple) {
            this.allowMultiple = storageHelperOptions.allowMultiple;
        }
        this.getUserConfiguration = storageHelperOptions.getUserConfiguration;
        this.setUserConfiguration = storageHelperOptions.setUserConfiguration;
        this.removeUserConfiguration = storageHelperOptions.removeUserConfiguration;
    }
    StorageHelper.prototype.getStorageValues = function (key) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var options, storageString, storageConversion;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.type === 'DB')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getUserConfiguration(key)];
                    case 1: return [2 /*return*/, _b.sent()];
                    case 2:
                        options = this.getStorageOptions();
                        storageString = (_a = options) === null || _a === void 0 ? void 0 : _a.target.storage.getItem(key);
                        if (storageString) {
                            if (obfuscation_1.isObfuscated(storageString)) {
                                storageString = obfuscation_1.deObfuscate(storageString);
                            }
                            storageConversion = json_1.jsonTryParse(storageString);
                            if (storageConversion.isValid) {
                                return [2 /*return*/, Promise.resolve(storageConversion.value)];
                            }
                        }
                        return [2 /*return*/, Promise.resolve(undefined)];
                }
            });
        });
    };
    StorageHelper.prototype.setStorageValues = function (key, value) {
        return __awaiter(this, void 0, void 0, function () {
            var storageValue, options;
            return __generator(this, function (_a) {
                if (this.type === 'DB') {
                    return [2 /*return*/, this.setUserConfiguration(key, value)];
                }
                storageValue = JSON.stringify(value);
                if (this.obfuscated) {
                    storageValue = obfuscation_1.obfuscate(storageValue);
                }
                options = this.getStorageOptions();
                if (options) {
                    if (!this.allowMultiple) {
                        options.clear.storage.removeItem(key);
                    }
                    options.target.storage.setItem(key, storageValue);
                    return [2 /*return*/, Promise.resolve(true)];
                }
                return [2 /*return*/, Promise.resolve(false)];
            });
        });
    };
    StorageHelper.prototype.removeStorageValues = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var options;
            return __generator(this, function (_a) {
                if (this.type === 'DB') {
                    return [2 /*return*/, this.removeUserConfiguration(key)];
                }
                options = this.getStorageOptions();
                if (options) {
                    options.target.storage.removeItem(key);
                    options.clear.storage.removeItem(key);
                    return [2 /*return*/, Promise.resolve(true)];
                }
                return [2 /*return*/, Promise.resolve(false)];
            });
        });
    };
    StorageHelper.prototype.getStorageOptions = function () {
        var options;
        // Have to access the storage from the window object, for the sake of the tests
        var localStorageOption = {
            storage: window.localStorage,
        };
        var sessionStorageOption = {
            storage: window.sessionStorage,
        };
        switch (this.type) {
            case 'LOCAL':
                options = {
                    target: localStorageOption,
                    clear: sessionStorageOption,
                };
                break;
            case 'SESSION':
                options = {
                    target: sessionStorageOption,
                    clear: localStorageOption,
                };
                break;
        }
        return options;
    };
    return StorageHelper;
}());
exports.StorageHelper = StorageHelper;
//# sourceMappingURL=StorageHelper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/helpers/StorageHelper.js
// module id = 739
// module chunks = 1